/**
 * Painel.
 *
 * Reexportado por `../resources.ts`. Ver docs/FRONTEND.md, secao 3.
 */

import type { Money } from './comum';

import { api } from '../client';

export interface DashboardSummary {
  operations: {
    open: number;
    issued: number;
    declined: number;
    overdue: number;
    insured_amount_open: Money;
    premium_issued: Money;
  };
  operations_by_stage: Record<string, number>;
  brokers_by_stage: Record<string, number>;
  policyholders_by_status: Record<string, number>;
  derived: {
    conversion_bps: number;
    average_ticket: Money;
    commissions_this_month: Money;
    expiring_in_30_days: number;
  };
  monthly_series: { competence: string; count: number; premium: Money }[];
  modality_breakdown: {
    modality_id: string;
    label: string;
    count: number;
    premium: Money;
  }[];
  generated_at: string;
}

export const dashboard = {
  summary: (signal?: AbortSignal) =>
    api.get<DashboardSummary>('/api/v1/dashboard/summary', signal),
};
